import { createSelector, createFeatureSelector } from '@ngrx/store';

import { EnvironmentalImpactState } from '../environmental-impact.models';

export const getEnvironmentalImpactState = createFeatureSelector<EnvironmentalImpactState>('environmentalImpact');

export const getEnvironmentalImpactsWithBenchmarks = createSelector(getEnvironmentalImpactState, (store) => store.environmentalImpactsWithBenchmarks || []);

export const selectEnvironmentalImpactsDeliveriesDivided = createSelector(
  getEnvironmentalImpactState,
  (store) =>
    store.environmentalImpactDeliveries
      .map((delivery) => ({
        ...delivery,
        values: {
          waterLife: delivery.values.waterLife / 1000,
          soilLife: delivery.values.soilLife / 1000,
          groundwaterWashout: delivery.values.groundwaterWashout / 1000,
        },
      }))
      .sort((a, b) => a.year - b.year) || [],
);
